import { colors, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  autoChip: {
    height: 18,
    marginLeft: theme.spacing(0.5),
    fontSize: 10,
    backgroundColor: colors.pink[100],
    color: colors.pink[900],
  },
  prioritySevere: {
    color: theme.palette.error.main,
    fontWeight: 600,
  },
  priorityHigh: {
    color: theme.palette.warning.main,
    fontWeight: 600,
  },
  priorityMedium: {
    color: theme.palette.info.main,
    fontWeight: 600,
  },
  priorityLow: {
    color: theme.palette.success.main,
    fontWeight: 600,
  },
  columnChip: {
    fontWeight: 600,
  },
  dpoChip: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.common.white,
    fontSize: 10,
    height: 16,
    fontWeight: 600,
    '& .MuiChip-label': {
      padding: '0 6px',
    },
  },
  deadlineOverdue: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    borderRadius: 4,
    padding: '1px 6px',
  },
  responsibleRow: {
    gap: 6,
  },
}))

export default useStyles
